
<div class="container">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">

      <div class="auth-box">

        <!-- logo -->
        <div class="logo-above-auth-box logo-tenant-as-background"></div>

        <!-- content -->
        <div class="auth-box-content-wrapper">

          <h2 class="auth-box_title">{{ 'reset.title-success' | translate }}</h2>

          <p>
            <strong>{{ 'reset.success-msg' | translate }} </strong><br/>
          </p>
          
          <a routerLink="/login" class="btn btn-lg btn-success btn-block">
            {{ 'activate.to-login' | translate }}
          </a>

        </div> <!-- // auth box content wrapper -->

      </div> <!-- // auth box -->

    </div>
  </div>
</div>
